<script>
  import { navigate } from "svelte-routing";
    
    
    let username=localStorage.getItem("username");
    let email =localStorage.getItem("email")
    let profile=localStorage.getItem("profile")
    function logout(){
        localStorage.clear("username");
        localStorage.clear("email");
        localStorage.clear("token");
        localStorage.clear("profile");

        navigate('/')

    }  
</script>

<!-- Main Menu -->
<div class="topbar">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-5 hidden-xs">
                <div class="logo">
                    <a href="/">
                        <span class="logo-emblem"><img
                                src="https://bootadmin.org/images/boot.png"
                                alt="BA" /></span>
                        <span class="logo-full">KalaPutri</span>
                    </a>
                </div>
                <a href="#" class="menu-toggle wave-effect">
                    <i class="feather icon-menu" />
                </a>
            </div>
            <div class="col-md-7 text-right">
                <ul>
                    <!-- Profile Menu -->
                    <li class="btn-group user-account">
                        <a
                            href="javascript:;"
                            class="btn dropdown-toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false">
                            <div class="user-content">
                                <div class="user-name">
                                    {username}
                                </div>
                                <div class="user-plan">
                                    {email}
                                </div>
                            </div>
                            <div class="avatar">
                                <img
                                    src="{profile}"
                                    alt="profile" />
                            </div>
                        </a>
                        <ul
                            class="dropdown-menu dropdown-menu-right">
                            <li>
                                <a
                                    href="/account/profile"
                                    class="animsition-link dropdown-item wave-effect"><i
                                        class="feather icon-user" />
                                    Profile</a>
                            </li>
                            <li>
                                <a
                                    href="/account/billing"
                                    class="animsition-link dropdown-item wave-effect"><i
                                        class="feather icon-dollar-sign" />
                                    Billing</a>
                            </li>
                            <li>
                                <a
                                    href="/account/settings"
                                    class="animsition-link dropdown-item wave-effect"><i
                                        class="feather icon-settings" />
                                    Settings</a>
                            </li>
                            <li>
                                <!-- svelte-ignore a11y-missing-attribute -->
                                <a
                                   on:click={()=>logout()}
                                    class="animsition-link dropdown-item wave-effect"><i
                                        class="feather icon-log-in" />
                                    Logout</a>
                            </li>
                        </ul>
                    </li>
                    <!-- Offcanvas Menu -->
                    <li>
                        <a
                            href="#"
                            class="btn wave-effect offcanvas-toggle"><i
                                class="feather icon-settings" /></a>
                    </li>
                    <!-- Notification Menu -->
                    <li class="btn-group notification">
                        <a
                            href="javascript:;"
                            class="btn dropdown-toggle wave-effect"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false">
                            <i class="feather icon-bell"><span
                                    class="notification-count">27</span></i>
                        </a>
                        <ul
                            class="dropdown-menu dropdown-menu-right">
                            <li>
                                <a href="#" class="wave-effect">
                                    <span class="avatar">
                                        <img
                                            src="https://bootadmin.org/images/demo/profile.png"
                                            alt="Mr. Chu" />
                                    </span>
                                    <span class="name">Jas
                                        Gillionaire</span>
                                    <span class="message">Like your
                                        post: “Contact Form 7
                                        Multi-Step”</span>
                                    <span class="time">45 min</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" class="wave-effect">
                                    <span class="avatar">
                                        <img
                                            src="https://bootadmin.org/images/demo/user.jpg"
                                            alt="Andrew" />
                                    </span>
                                    <span class="name">Gurinder
                                        Singh</span>
                                    <span class="message">Like your
                                        post: “Contact Form 7
                                        Multi-Step”</span>
                                    <span class="time">45 min</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" class="wave-effect">
                                    <span class="avatar">
                                        <img
                                            src="https://bootadmin.org/images/demo/profile.png"
                                            alt="Mr. Chu" />
                                    </span>
                                    <span class="name">Andrew the
                                        Canadian</span>
                                    <span class="message">Like your
                                        post: “Contact Form 7
                                        Multi-Step”</span>
                                    <span class="time">45 min</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" class="wave-effect">
                                    <span class="avatar">
                                        <img
                                            src="https://bootadmin.org/images/demo/user.jpg"
                                            alt="Mr. Chu" />
                                    </span>
                                    <span class="name">Artsy Shohan</span>
                                    <span class="message">Like your
                                        post: “Contact Form 7
                                        Multi-Step”</span>
                                    <span class="time">45 min</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" class="wave-effect">
                                    <span class="avatar">
                                        <img
                                            src="https://bootadmin.org/images/demo/profile.png"
                                            alt="Mr. Chu" />
                                    </span>
                                    <span class="name">Sazzad
                                        Shammad</span>
                                    <span class="message">Like your
                                        post: “Contact Form 7
                                        Multi-Step”</span>
                                    <span class="time">45 min</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/notification"
                                    class="dropdown-item all-notifications wave-effect">See
                                    more messages
                                    <i
                                        class="feather icon-arrow-down" /></a>
                            </li>
                        </ul>
                    </li>
                    <li class="mobile-menu-toggle">
                        <a href="#" class="menu-toggle wave-effect">
                            <i class="feather icon-menu" />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>